import _ from './underscore-wrapper';
import BaseView from '../views/BaseView';
export default {
  redirect: function (url) {
    window.location = url;
  },

  reloadPage: function () {
    window.location.reload();
  },

  constantError: function (errorMessage) {
    return function () {
      throw new Error(errorMessage);
    };
  },

  /**
   * Simply convert an URL query key value pair object into an URL query string.
   * Remember NOT to escape the query string when using this util.
   * example:
   * input: {userId: 123, instanceId: undefined, expand: 'schema,app'}
   * output: '?userId=123&expand=schema,app'
   */
  getUrlQueryString: function (queries) {
    _.isObject(queries) || (queries = {});

    const queriesString = _.without(
      _.map(queries, function (value, key) {
        if (value !== undefined && value !== null) {
          return key + '=' + encodeURIComponent(value);
        }
      }),
      undefined
    ).join('&');

    return _.isEmpty(queriesString) ? '' : '?' + queriesString;
  },

  isABaseView(obj) {
    return obj instanceof BaseView || obj.prototype instanceof BaseView || obj === BaseView;
  }
};



// WEBPACK FOOTER //
// /Users/aarongranick/okta/okta-ui/packages/courage/src/util/Util.js


// WEBPACK FOOTER //
// webpack:///Users/aarongranick/okta/okta-ui/packages/courage/src/util/Util.js